module.exports = __webpack_public_path__ + "static/media/T12_headboard Finishing_Fabric_Taupe.25755159.png";